import React, { useState } from "react";
import { toastMessage } from "../../../utils/toastMessage";
import {
  allowAlphaNumericWithLeadingAlpha,
  allowNumber,
  areMandatoryFieldsFilled,
} from "../../../utils/inputValueValidation";
import contact_img from "../../../assets/contact_img.png";
import { contentUsApi } from "../../../services/common";
import { LoadingButton } from "../../../Components/header/form";
const ContentUs = () => {
  const [loader, setLoader] = useState(false);
  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  // console.log('areMandatoryFieldsFilled', !areMandatoryFieldsFilled)

  const requiredFields = ["name", "email", "message", "phone"];

  const formFields = {
    name: contactData?.name,
    email: contactData?.email,
    message: contactData?.message,
    phone: contactData?.phone,
  };
  //----------create-content-us-API-----------------------
  const contentUs = async (e) => {
    e.preventDefault();
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        contactData?.email
      )
    ) {
      toastMessage("Invalid email format", "error", "email");
      return;
    }
    try {
      setLoader(true);
      const res = await contentUsApi(contactData);
      if (res?.data?.success) {
        setContactData({ name: "", email: "", message: "", phone: "" });
        toastMessage(res?.data?.message, "success", "Contact Us");
      } else {
        toastMessage(res?.data?.message, "error", "Contact Us");
      }
    } catch (e) {
      toastMessage(
        "Failed to submit. Please try again!",
        "error",
        "Contact Us"
      );
      console.log(e);
    } finally {
      setLoader(false);
    }
  };
  return (


    <section className="contact_us" id="contact">
      <div className="custom_container">
        <div className="contact_heading">
          <div className="row">
            <div className="col-md-12">
              <div className="contact_us_title">
                <h4>CONTACT US</h4>
              </div>
              <div className="key_heading contact">
                <h2>Get in touch with us.</h2>
              </div>
            </div>

            <div className="contact_heading">
              <div className="custom_container">
                <div className="row contactus_row">
                  <div className="col-sm-6 col-md-6 col-lg-5">
                    <div className="contact_img">
                      <img src={contact_img} />

                      <p>
                        In case of any issues during login/sign-up, drop a
                        WhatsApp at +1 905 490 1212
                      </p>
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="contact_form">
                      <div className="form-container">
                        <form>
                          <div className="form_field_wrap">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-input contact"
                                placeholder="Name*"
                                required
                                name="name"
                                value={contactData?.name}
                                onChange={(e) =>
                                  setContactData({
                                    ...contactData,
                                    name: allowAlphaNumericWithLeadingAlpha(
                                      e.target.value
                                    ),
                                  })
                                }
                              />
                            </div>
                            <div className="form-group">
                              <input
                                type="tel"
                                className="form-input contact"
                                placeholder="Phone No*"
                                required
                                maxLength={15}
                                name="phone"
                                value={contactData?.phone}
                                onChange={(e) =>
                                  setContactData({
                                    ...contactData,
                                    phone: allowNumber(e.target.value),
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-input contact"
                              placeholder="Email*"
                              required
                              name="email"
                              value={contactData?.email}
                              onChange={(e) =>
                                setContactData({
                                  ...contactData,
                                  // email: e.target.value,
                                  email: e.target.value
                                    .replace(/[^a-zA-Z0-9@._]/g, "")
                                    .toLowerCase(),
                                })
                              }
                            />
                          </div>
                          <div className="form-group">
                            <textarea
                              className="form-input form-textarea contact"
                              placeholder="Message*"
                              required
                              name="message"
                              value={contactData?.message}
                              onChange={(e) =>
                                setContactData({
                                  ...contactData,
                                  message: e.target.value,
                                })
                              }
                            />
                          </div>
                          <LoadingButton
                            loading={loader}
                            type="submit"
                            disabled={
                              !areMandatoryFieldsFilled(
                                formFields,
                                requiredFields
                              )
                            }
                            onClick={contentUs}
                            className={`form-button ${
                              !areMandatoryFieldsFilled(
                                formFields,
                                requiredFields
                              )
                                ? "cstm_disabled_btn"
                                : ""
                            }`}
                          >
                            Send
                          </LoadingButton>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <hr className="horizontal"/> */}
      </div>
    </section>

    
  );
};

export default ContentUs;
